<template>
  
  <div :id="_uid" class="ui tiny modal" :class="modalSelector">
    <div class="ui header">
      {{ title || "Atenção" }}
    </div>
    <div class="content">
      <p v-if="htmlMessage" v-html="htmlMessage"></p>
      <p v-else>{{ message || "Confirma ?" }}</p>
    </div>
    <div class="actions">
      <button class="ui basic button" @click="emit('onNo')">
        <i class="remove icon"></i>
        Não
      </button>      
      <button class="ui button" :class="{ 'blue': !danger, red: danger }" @click="emit('onYes')">
        <i class="checkmark icon"></i>
        Sim
      </button>
    </div>
  </div>

</template>

<script>

  export default {

    name: "YesNoModal",

    data() {
      return {
        emitEvent: null,
      }
    },
    
    props: ["title", "message", "htmlMessage", "danger"],

    mounted() {
      $("#" + this._uid).modal({ 
        allowMultiple: true,
        onHidden: this.onHidden,
      })
    },
    
    beforeDestroy() {
      $("." + this.modalSelector).remove()
    },

    computed: {

      modalSelector() {
        return this._uid + "_modal"
      },
    },

    methods: {

      emit(event, data) {
        this.emitEvent = { event, data }
        this.hide()
      },

      show() {
        this.emitEvent = null
        $("#" + this._uid).modal("show")
      },

      hide() {
        $("#" + this._uid).modal("hide")
      },

      onHidden() {
        if (this.emitEvent)
          this.$emit(this.emitEvent.event, this.emitEvent.data)
      },
    },
  }

</script>

